import { render, staticRenderFns } from "./SlotsPage.vue?vue&type=template&id=0dbf2e4d&scoped=true&lang=pug&"
import script from "./SlotsPage.vue?vue&type=script&lang=js&"
export * from "./SlotsPage.vue?vue&type=script&lang=js&"
import style0 from "./SlotsPage.vue?vue&type=style&index=0&id=0dbf2e4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbf2e4d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VContainer,VIcon,VNavigationDrawer,VToolbarTitle})
